import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TakeControl } from '../components/TakeControl';
import { WhyResidents } from '../components/WhyResidents';
import { ActiveLiving } from '../components/ActiveLiving';
import { DifferentKind } from '../components/DifferentKind';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Landing() {
  return <div id="top" className="w-full bg-cream" data-id="element-119" data-mp="3ulas8yom8rp7">
      <Header data-id="element-120" data-mp="3gaocjijq0g0" />
      <main data-id="element-121" data-mp="3fsxk2enkefh">
        <Hero data-id="element-122" data-mp="3fj6ebhvg187" />
        <TakeControl data-id="element-123" data-mp="3ezmwqckp4s2" />
        <WhyResidents data-id="element-124" data-mp="87spb7kkk10z" />
        <ActiveLiving data-id="element-125" data-mp="87kctgscyxqb" />
        <DifferentKind data-id="element-126" data-mp="893th8hxfasm" />
        <FinalCTA data-id="element-127" data-mp="89x4wmrtyoh3" />
      </main>
      <Footer data-id="element-128" data-mp="c95xhob4wgb2" />
    </div>;
}